// import APIs
import { getRosterPublishDate } from 'RestAPIs/roster/publish-date';

// import external libraries
import { useQuery } from 'react-query';

export type GetOpenRequestsProps = {
  costCenters: string;
  startDate: string;
  endDate: string;
};

const useGetRosterPublishDate = (
  { costCenters, startDate, endDate }: GetOpenRequestsProps,
  options: Record<string, any> = {}
) => {
  const { data, isFetching, isError, refetch } = useQuery(
    ['rosterPlanPublishDate', costCenters, startDate, endDate],
    async () => {
      const { data } = await getRosterPublishDate({
        costCenters,
        startDate,
        endDate
      });
      return data;
    },
    options
  );
  return { data, isFetching, isError, refetch };
};

export default useGetRosterPublishDate;
